import React from 'react';
import PropTypes from 'prop-types';

import * as S from './bundle-tile.module.scss';

// Components
import { ProductName } from '../../../common/product/prod-name';
// import { Price } from '../../../common/product/price';
import { Expiry } from '../../../common/product/expiry';
import { TagLine } from '../../../common/product/tag-line';
// import { TileCoTermMiniSub } from './coterm-mini-sub-tile';
// import { SingleProductRow } from '../unified-sub-tile/product-single-row';

// Context Functions
// import * as ProductSelectors from '../../../../context/selectors/product-selectors';
// import * as UserSelectors from '../../../../context/selectors/user-selectors';
import { setCtxNestedObj } from '../../../../context/ctx-actions';
// import { getMaxEntitlement,
// getBmTierData
// }    from '../../../../context/selectors/bill-selectors';

import { useGlobalCtx } from '../../../../context/ctx-hook';
import { getEStoreCartUrlAddProduct } from '../../../../helpers/route-helper';
// import { CancelDowngradeBox } from '../../../modals/change-plans/cancel-downgrade';

import * as StateConstants from '../../../../helpers/constants/state-constants';

import { getProductLogo } from '../../../../context/selectors/product-selectors';
import { useAutoRenew } from '../../../../helpers/hooks/use-auto-renew';
import { getProductsPaymentMethod } from '../../../../context/selectors/user-selectors';
import * as BillSelector from  '../../../../context/selectors/bill-selectors';
import { TileBm } from '../tile-bm/bm-tile';
import { getSubscription } from '../../../../context/selectors/product-selectors';
import { SingleProductRow } from '../unified-sub-tile/product-single-row';
import { getQknSubscription } from '../../../../context/selectors/bill-selectors';

const getSubMsg = (bundleSub, hasPayment) => {
  const SUB = bundleSub.bundleSub;
  if (!SUB.active) {
    return {
      title: 'Expired Subscription',
      message: 'This subscription is no longer active',
    };
  } else if (!hasPayment) {
    return {
      title: 'No Payment Method',
      message: 'In order to not lose your connected services, add a payment method for renewal'
    };
  } else if (!SUB.autoRenew) {
    return {
      title: 'Renewal Canceled',
      message: 'Your subscription has been canceled but it is still valid until your expiration date. In order to avoid expiration, you must resume your subscription.'
    };
  } else {
    return false;
  }
};

const TileBundle = ({isModal = false, bundleSub}) => {
  const {globalDispatch, state} = useGlobalCtx();
  const BUNDLE_HAS_QKN = getQknSubscription(state, state?.country)?.txnId || false;

  // This check is only for if they have QOB that is NOT in their bundle
  // If so then we show them a seperate 'addon' tile thing
  const QOB_SUB = getSubscription(state, 'quicken-online-backup', false);

  const {
    active,
    autoRenew
  } = bundleSub.bundleSub;

  const HAS_PAYMENT  = getProductsPaymentMethod('bundle', state);
  const handleAROn = useAutoRenew('bundle', true, bundleSub.txnId);

  // Bill Manager Shenangians
  const BM_TYPE = BillSelector.getBillManagerType(state);
  const QKN_SUB = BillSelector.getQknSubscription(state, state?.country);
  const QKN_SUB_OBJ = BillSelector.getQknSubscriptionObj(QKN_SUB, state?.country);
  const BM_MAX_ENT = QKN_SUB ? BillSelector.getMaxEntitlement(state) : false;
  const BM_DATA = QKN_SUB ? BillSelector.getBmTierData(BM_MAX_ENT) : false;
  // End of Bill Manager Shenangians

  const updatePaymentModal = React.useCallback(
    () => globalDispatch(setCtxNestedObj('modal', {
      type:       StateConstants.MODALS.UPDATE_PAYMENT,
      ctx:        { product: 'bundle', paymentOnly: false, isDefaultPayment: true},
      isLoading:  true,
      hasError:   false,
      isDisabled: false
    })),
    [globalDispatch, 'bundle']
  );

  const manageSubscription = React.useCallback(
    async () => globalDispatch(setCtxNestedObj('modal', {
      type:       StateConstants.MODALS.SUBSCRIPTION,
      ctx:        {product: [bundleSub]},
      isLoading:  true,
      hasError:   false,
      isDisabled: false
    })),
    [globalDispatch, bundleSub]
  );




  // console.log('bundleSub', bundleSub);
  return (
    <div className={isModal ? S.bundleWrapper : S.bundleWrapper} data-testid="SUB_BUNDLE">
      <div className={`${S.tile}`}>
        <div className={S.subTileContain}>

          <div className={S.subTileLeft}>
            {/* <div className={S.grpWrapper} key={i}> */}
            <div className={S.productRow} >
              {/* <img className={S.rowLogo} alt="square product logo" src={RedSquareLogo}></img> */}
              <img alt="square product logo" src={getProductLogo(bundleSub, true)} />
              <div className={S.productName}>
                <ProductName customName={bundleSub.bundleSkuData.display_name} className={S.acmeName} nameStyle='inline'/>
                <div className={S.subNamesContain}>
                  {bundleSub?.subscriptions?.map((sub, i) => {
                    return (
                      <div className={S.subName} key={i}>
                        + <ProductName sub={sub} product={sub.productName} className={S.name} nameStyle='inline'/>
                      </div>
                    );
                  })}
                </div>
                {/* <TagLine uriName={'bundle'} className={S.tagLine} /> */}
              </div>
            </div>

            {BUNDLE_HAS_QKN && BM_TYPE ==='FREE' && BM_DATA &&
              <div className={S.productRow}>
                <img className={S.rowLogo} alt="square product logo" src={getProductLogo(QKN_SUB_OBJ)}></img>
                <div className={S.productName}>
                  <ProductName sub={BM_DATA} product={BM_DATA.productName} className={S.acmeName} nameStyle='inline'/>
                  <TagLine uriName={BM_DATA.tier} className={S.tagLine} />
                </div>
              </div>
            }
            {/* </div> */}

            {getSubMsg(bundleSub, HAS_PAYMENT) &&
              <div className={S.msgs}>
                <div className={S.productAlert}>
                  <p className={S.messageTitle}>{getSubMsg(bundleSub, HAS_PAYMENT).title}</p>
                  <p>{getSubMsg(bundleSub, HAS_PAYMENT).message}</p>
                </div>
              </div>
            }
          </div>

          <div className={S.subTileRight}>
            <div className={`${S.actionBtnWrapper}`} >
              {!isModal && active && autoRenew && HAS_PAYMENT && (
                <button
                  type="button"
                  data-testid="BTN_BUNDLE_MANAGE_SUB"
                  onClick={manageSubscription}
                  className={S.ctaBtnInvert}
                >Manage Subscription</button>
              )}

              {/* {active && autoRenew && !HAS_PAYMENT && (
                <button
                  type="button"
                  data-testid="BTN_QKN_ADD_BILLING"
                  onClick={handleUpdateBilling}
                  className={S.ctaBtnInvert}
                >Add Billing</button>
              )} */}

              {active && !autoRenew && (
                <>
                  <button
                    type="button"
                    data-testid="QKN_RESTART_SUB"
                    onClick={HAS_PAYMENT ? handleAROn : updatePaymentModal}
                    className={S.ctaBtn}
                    disabled={state.isDisabled}
                  >Resume Subscription</button>
                </>
              )}

              {!active && !autoRenew && (
                <a
                  data-testid="LINK_BUY_NOW_QKN"
                  className={S.ctaBtn}
                  href={getEStoreCartUrlAddProduct(bundleSub?.bundleSkuData?.RenewalSKU, state.country)}
                >Buy Now</a>
              )}
            </div>

            <Expiry customSub={bundleSub.bundleSub} className={S.productExpiry} />
          </div>


        </div>

        {BUNDLE_HAS_QKN && QOB_SUB &&
          <SingleProductRow sub={QOB_SUB} isModal={false} />
        }

        {BUNDLE_HAS_QKN &&
          <TileBm />
        }
      </div>
    </div>
  );
};

TileBundle.displayName  = 'TileBundle';
TileBundle.propTypes    = {
  isModal: PropTypes.bool,
  bundleSub:    PropTypes.object
};
TileBundle.defaultProps = {
  isModal: false,
  subs: []
};

export { TileBundle };